import { render } from "./highlight.vue?vue&type=template&id=c4d3a81c"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__